import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/ippta';
const endpointExport = '/api/ipptaExportable';

const getIppta = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los reportes:', error);
    throw error; // Lanza el error para ser manejado en el componente React
  }
};

const deleteIppta = async (id, userLogin) => {
  try {
    const response = await axios.delete(`${baseUrl}/api/ippta/${id}`, {
      data: { user: userLogin },
    });

    return response.data;
  } catch (error) {
    console.error("Error eliminando IPPTA:", error);
    throw error;
  }
};

const getIpptaExportable = async () => { 
  try {
    const response = await axios.get(`${config.baseUrl}${endpointExport}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los reportes:', error);
    throw error; // Lanza el error para ser manejado en el componente React
  }
};


export { getIppta, getIpptaExportable, deleteIppta };
